import PropTypes from 'prop-types';

import { TrlCheckButton } from '»components/atoms';

import { CheckboxContainer, CheckboxText } from './TrlCheckboxField.styles';

export const TrlCheckboxField = ({
  id,
  checked,
  handleCheckboxChange,
  isCheckboxDisabled,
  checkboxText,
  hasHtmlTagsInCheckboxText,
}) => (
  <CheckboxContainer id={id}>
    <TrlCheckButton
      value={checked}
      handleChange={handleCheckboxChange}
      disabled={isCheckboxDisabled}
      size="small"
    />
    {hasHtmlTagsInCheckboxText ? (
      <CheckboxText
        disabled={isCheckboxDisabled}
        dangerouslySetInnerHTML={{ __html: checkboxText }}
      />
    ) : (
      <CheckboxText disabled={isCheckboxDisabled}>{checkboxText}</CheckboxText>
    )}
  </CheckboxContainer>
);

TrlCheckboxField.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.string.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  isCheckboxDisabled: PropTypes.bool,
  checkboxText: PropTypes.string,
  hasHtmlTagsInCheckboxText: PropTypes.bool,
};
